import React from 'react';
import LivePage from '../LivePage';
import LegoAdminPageContext from '../legoAdminPageContext';
import { IconButton } from '../../components/common/IconButton';
import submenuCerokm from '../menus/submenu-cerokm';
import AIModelBadge from '../../components/ai/AIModelBadge';
import _ from 'lodash';
import LegoContextSummary from '../../components/lego/LegoContextSummary';
import SingleTextEditor from '../../components/common/editors/SingleTextEditor';
import JSONPreview from '../../components/common/JSONPreview';
import { TableWithSelection } from '../../components/common/editors/TableWithSelection';
import LLMPromptModal from './components/LLMPromptModal';
import { SwitchInput } from '../../components/common/SwitchInput';
import { Icon } from '../../components/common/Icon';
import FragmentsUsingSpec from './components/FragmentsUsingSpec';
import SchemaPathInput from './spec-schema-editor/SchemaPathInput';
import FragmentSourceEditor from './components/FragmentSourceEditor';

function ProposedValueMetadataEditor({ value, onChange }) {
  let { note, touchedManually, source, sourceUrl } = value;
  return <div>
    <FragmentSourceEditor value={source} onChange={(v) => onChange({ ...value, source: v })} />

    <IconButton icon={'sticky_note_2'} level={note ? 'primary' : 'secondary'} onClick={() => !note && onChange({ ...value, note: note == '' ? undefined : '' })} title='Add additional context...' />

    {touchedManually && ' ✏️'}

    {sourceUrl !== undefined || source === 'web' ? <SingleTextEditor placeholder="Source url..." className='monospace zoom-75' small value={sourceUrl || ''} onChange={(v) => onChange({ ...value, sourceUrl: v })} /> : null}

    {note !== undefined ? <SingleTextEditor placeholder="Add additional context..." className={note ? '' : 'bg-transparent'} small value={note} onChange={(v) => onChange({ ...value, note: v })} /> : null}
  </div>
}

function linkSpecGroup(specsGroupId, modelId) {
  return `/cerokm/fragments/?filters=${encodeURIComponent(JSON.stringify({ specsGroupIds: specsGroupId, context: { modelId } }))}`;
}


class CeroKmMissingSpecsManager extends LivePage {
  constructor(props) {
    super(props);
    // this.svcSource = this.service('services/cerokm/source');

    this.svcSpecsNotice = this.service('services/cerokm/specsnotice');
    this.svcSpecs = this.service('services/cerokm/specs');
    this.svcPromptMissingSpec = this.service('services/cerokm/promptmissingspec');
    this.svcFragments = this.service('services/cerokm/sourcefragment');
    this.svcAi = this.service('services/cerokm/ai/process-fragments');

    this.submenu = submenuCerokm;

    this.state.filters = this.getUrlParam('filters', true);
    this.state.specPath = this.getUrlParam('specPath', true) || 'powertrain.type';
    // this.state.proposedValues = {};
    this.state.proposedValues = {};
    this.state.selected = [];
    this.state.defaultSourceContext = '';
    this.state.viewAllExisting = false;
  }

  componentDidMount() {
    this.refresh();
  }

  async refresh() {
    this.runAsync((async () => {
      // const notices = await this.svcSpecsNotice.find({ query: { type: 'requiredMissing', specPath: '' } });
      const $select = {
        'specs.commercial.price.baseMSRP': 1
      };
      const specs = await this.svcSpecs.get(this.state.specPath, { query: { $select } });
      const notices = await this.svcSpecsNotice.find({
        query: {
          type: 'requiredMissing',
          specPath: this.state.specPath,
          $select
        }
      });

      this.setUrlParam('specPath', this.state.specPath);
      this.setState({ specs, notices, resultsSpecPath: this.state.specPath });
    })(), 'Loading missing spec data...');
  }

  traceToFragments(doc) {
    this.openModal(<FragmentsUsingSpec path={this.state.specPath} specsGroupId={doc.specsGroupId} />, { title: 'Factoids using spec ', fullScreen: true });
  }

  renderSpecsTable() {
    const { specs, notices, specPath, viewAllExisting, proposedValues, filter, resultsSpecPath, selected } = this.state;
    if (!specs) return null;

    let filterRegex = null;
    if(filter) {
      try {
        filterRegex = new RegExp(filter, 'i');
      } catch(e) {
        filterRegex = new RegExp(_.escapeRegExp(filter), 'i');
      }
    }

    const allDocs = [...specs, ...notices]

    const docsById = _.keyBy(allDocs, '_id');

    // First group by modelId and ver
    const groupedByModelVer = _.groupBy(allDocs, doc =>
      `${doc.context.modelId}-${doc.context.ver || ''}`
    );

    // Build rows array
    const rows = [];
    let rowNum = 1;

    const batchEditProposedValues = (id, valueFunc) => {
      const newProposedValues = { ...proposedValues };
      let ids = [id];

      if(this.state.selected.includes(id)) {
        ids = this.state.selected;
      }

      for(const id of ids) {
        let old = newProposedValues[id];
        newProposedValues[id] = valueFunc(old, id);
      }
      this.setState({ proposedValues: newProposedValues });
    };

    // Sort the model-ver groups
    const sortedModelVerGroups = _.sortBy(Object.entries(groupedByModelVer), ([key]) => key);

    sortedModelVerGroups.forEach(([modelVerKey, modelVerDocs]) => {
      const firstDoc = modelVerDocs[0];
      const modelVerHeader = `${firstDoc.context.modelId}${firstDoc.context.ver ? `-${firstDoc.context.ver}` : ''}`;

      // Add model-ver header row
      const thereAreMissingInModel = modelVerDocs.some((doc) => _.get(doc.specs, this.state.resultsSpecPath) === undefined);
      if (thereAreMissingInModel || viewAllExisting) {
        rows.push(
          <tr key={`modelver-${modelVerKey}`} className="bg-secondary text-white font-weight-bold">
            <td colSpan={7} className="fw-bold">
              {modelVerHeader}
            </td>
          </tr>
        );
      }


      // Group by trim within each model-ver group
      const groupedByTrim = _.groupBy(modelVerDocs, doc => doc.context.trim || '');
      const sortedTrimGroups = _.sortBy(Object.entries(groupedByTrim), ([key]) => key);

      let prices = _.compact(_.map(modelVerDocs, 'specs.commercial.price.baseMSRP.value'));
      let minPrice = _.min(prices) || 0;
      let maxPrice = _.max(prices) || 0;

      sortedTrimGroups.forEach(([trimKey, trimDocs]) => {
        // const thereAreMissingInTrim = trimDocs.some((doc) => _.get(doc.specs, this.state.resultsSpecPath) === undefined);

        // Add data rows for this trim
        trimDocs.forEach(doc => {
          const specValue = _.get(doc.specs, this.state.resultsSpecPath);
          const proposedValue = proposedValues[doc._id];

          let rowClass = specValue === undefined ? (proposedValue ? 'bg-light-warning' : 'bg-light-danger') : '';

          if (specValue !== undefined && !thereAreMissingInModel && !viewAllExisting) {
            return null;
          }

          const rowNumber = specValue == undefined ? rowNum++ : '-';

          if(filterRegex && !filterRegex.test(`${modelVerHeader} ${doc.context.trim || ''} ${doc.trimDescription} ${JSON.stringify(specValue || '')}`)) {
            return null;
          }

          let price = _.get(doc, 'specs.commercial.price.baseMSRP.value', 0);
          let r = (price - minPrice) / (maxPrice - minPrice)
          let priceColor = price ? `color-mix(in lab, red ${r * 100}%, #0B0 ${100 - r * 100}%)` : 'rgb(128,128,128)';
          rows.push(
            <tr key={doc._id} className={rowClass}>
              <td style={{ width: '1px', whiteSpace: 'nowrap' }} className="text-muted">{rowNumber}</td>

              <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                <LegoContextSummary context={_.omit(doc.context, 'trim')} inline />
                <span className='text-secondary'>{doc.context.trim || ''}</span>
              </td>

              <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                <IconButton icon={'launch'} target='_blank' href={linkSpecGroup(doc.specsGroupId, doc.context.modelId)}>
                  <span className='text-dark'>{doc.trimDescription}</span>
                </IconButton>
              </td>

              <td>
                <span className='badge badge-success small' style={{ backgroundColor: priceColor }}>
                  $ {Math.round(price / 1000) || ' -'}k
                </span>
              </td>

              <td className='text-center monospace align-middle pl-3'>
                {specValue === undefined ?
                  <SingleTextEditor small
                    debounceMs={350}
                    className='text-left h-auto py-0'
                    value={proposedValue?.value || ''}
                    onChange={(value) => {
                      batchEditProposedValues(doc._id, old => ({
                        source: 'human',
                        ... old,
                        value,
                        touchedManually: old?.source !== 'human'
                      }));
                    }}
                  />
                  :
                  <div className='d-flex align-items-center'>
                    <IconButton level='secondary' icon={'search'} onClick={() => this.traceToFragments(doc)} />
                    <JSONPreview value={specValue} />
                  </div>
                }
              </td>

              <td className='text-left'>
                {specValue === undefined && proposedValue && (
                  <ProposedValueMetadataEditor value={proposedValue}
                    onChange={(v) => batchEditProposedValues(doc._id, old => ({
                      ... (old || {}),
                      ... v,
                      value: old?.value || v.value
                    }))}
                  />
                )}
              </td>

              <td className='text-left'>
                {specValue === undefined && proposedValue?.outputs && (
                  <div className="small">
                    {proposedValue.outputs.map((output, i) => (
                      <div key={i} className="mb-1">
                        <AIModelBadge model={output.model} /> {output.value}
                        <span className={`ml-1 badge ${output.confidence === 'high' ? 'badge-success' : 'badge-warning'}`}>{output.confidence}</span>
                      </div>
                    ))}
                  </div>
                )}
              </td>
            </tr>
          );
        });
      });
    });

    const onSelectionChange = (newSelected) => {
      // if(newSelected.length === rows.length) {
      // In select all, only leave trims
      newSelected = newSelected.filter(id => !id.startsWith('modelver-'));
      // }
      // Filter any row with specValue !== undefined
      newSelected = newSelected.filter(id => {
        const specValue = _.get(docsById[id]?.specs, resultsSpecPath);
        return !specValue;
      });
      this.setState({ selected: newSelected });
    }

    return (
      <TableWithSelection
        selected={selected}
        onSelectionChange={onSelectionChange}
        additiveSelection={true}
        style={{ tableLayout: 'auto', width: '100%' }}
        className={`small ${specPath !== resultsSpecPath ? 'translucent' : ''}`}
      >
        <thead>
          <tr className='bg-dark text-white'>
            <th>#</th>
            <th>Model and trim</th>
            <th>Config</th>
            <th>$</th>
            <th>{this.state.resultsSpecPath}</th>
            <th>Source</th>
            <th>LLM Outputs</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </TableWithSelection>
    );
  }

  async fillWithLLM() {
    this.openModal(
      <LLMPromptModal
        onSubmit={async (params) => {
          const result = await this.runAsync(async () => await this.svcPromptMissingSpec.create({
            ...params,
            selectedIds: this.state.selected
          }));

          // Update proposed values with results
          const newProposedValues = { ...this.state.proposedValues };
          _.each(result, (value, id) => {
            // Use the first model's output as the default value
            const firstOutput = value.outputs[0];
            newProposedValues[id] = {
              value: firstOutput.value,
              source: 'llm',
              touchedManually: false,
              outputs: value.outputs
            };
          });
          this.setState({ proposedValues: newProposedValues });
          this.closeModal();
        }}
        onCancel={() => this.closeModal()}
      />,
      { title: 'Fix with LLM' }
    );
  }

  async batchEdit() {
    // Handle bulk edit of selected items
    let input = await this.prompt('Enter the new value for the selected specs');
    if (input) {
      let newProposedValues = { ... this.state.proposedValues };
      _.each(this.state.selected, id => {
        newProposedValues[id] = {
          value: input,
          source: 'human',
          touchedManually: false
        };
      });
      this.setState({ proposedValues: newProposedValues });
    }
  }

  async createFragments() {
    // TODO: Group by basedOn of spec group
    const sources = [];

    const defaultNote = this.state.defaultSourceContext;

    // First group all the values exactly the same but splitted by modelId-ver
    const groupedFragments = _.groupBy(Object.entries(this.state.proposedValues), ([id, { value, source, note }]) => {
      let specsDoc = _.find(this.state.notices, { _id: id });
      if (!specsDoc) {
        alert("Spec doc Id not found: " + id);
        throw new Error("Id not found: " + id);
      }
      let context = specsDoc.context;
      return JSON.stringify([context.modelId, context.ver, value, source, note || defaultNote || ''])
    });

    const fragments = Object.entries(groupedFragments).map(([groupId, fragmentPairs]) => {
      let [[sampleId, sample]] = fragmentPairs;

      let note = sample.note || defaultNote;

      return {
        text: sample.value,
        type: 'textHardSpec',
        sourceIds: [{ sourceUrl: sample.sourceUrl || '', sourceType: sample.source }],        
        ... (note ? {
          notes: [{
            content: note,
            userId: this.getLoggedUserSignature().id,
            createdAt: new Date()
          }]
        } : {}),
        createdBy: this.getLoggedUserSignature(),
        specsGroupIds: fragmentPairs.map(([id]) => _.find(this.state.notices, { _id: id }).specsGroupId)
      };
    });

    if (!confirm(`Create ${fragments.length} new fragments?`)) {
      return;
    }

    // Create fragments
    const res = await this.runAsync(async () => await this.svcFragments.create(fragments), "Creating fragments...");

    // Parse new fragments
    await this.runAsync(this.svcAi.create({ fragmentIds: _.map(res, '_id') }), `Parsing ${res.length} new fragments...`);

    // Update affected specs group's specs
    const allSpecGroupIds = _.uniq(_.flatMap(res, 'specsGroupIds'));
    await this.runAsync(this.runServerScript('SaveSpecs', {specsGroupIds: allSpecGroupIds.join(',')}),  `Resaving the ${allSpecGroupIds.length} spec groups, waiting for script to finish...`);

    this.setState({ proposedValues: {}, selected: [] });
    this.refresh();
  }

  renderPageBody() {
    const { notices, filter, specs, proposedValues, viewAllExisting, defaultSourceContext, resultsSpecPath, specPath, selected } = this.state;

    const validProposedValues = _.values(proposedValues).filter(value => value?.value !== '' && value?.value !== null);

    return <div className={''}>
      <div className={'py-1 px-3 d-flex align-items-center bg-light border-bottom sticky-top'}>
        <h5 className='m-0'>Missing Spec</h5>
        <IconButton icon={'sync'} level={'primary'} className={'ml-2'} onClick={() => this.refresh()} />
        <div className='my-1' style={{ width: '350px' }}>
          <SchemaPathInput
            debounce={350}
            value={this.state.specPath}
            onChange={(specPath) => this.setState({ specPath: specPath.trim() })}           
          />
        </div>

        {!specs ? <span className='h5 text-secondary m-0 px-2'>
          Loading...
        </span> : null}

        <span className='h6 m-0 text-danger px-2'>
          ✘ {notices?.length} missing
        </span>

        <span className='h6 m-0 text-success px-2 ml-2'>
          ✔ {specs?.length}
        </span>

        <SwitchInput value={viewAllExisting} onChange={(viewAllExisting) => this.setState({ viewAllExisting })}>
          Show all
        </SwitchInput>

        <span className='ml-2'>
          <SingleTextEditor small debounceMs={350} placeholder='Filter by text...' value={filter} onChange={(filter) => this.setState({ filter })} />
        </span>

        {selected.length > 0 && (
          <div className="ml-auto d-flex align-items-center">
            <span className="text-muted mr-2">{selected.length} selected</span>

            <IconButton icon="auto_mode" level="primary" onClick={this.fillWithLLM.bind(this)}>Fill with LLM</IconButton>
          </div>
        )}
      </div>

      <div className={'py-1 px-3 d-flex align-items-center border-bottom ' + (validProposedValues.length ? 'bg-light-warning ' : 'bg-light  translucent')}>
        <span className='no-wrap mr-2'>Additional note on how data was processed:</span>

        <Icon icon={'sticky_note_2'} level={defaultSourceContext ? 'primary' : 'secondary'} />
        <span className='w-25'>
          <SingleTextEditor small debounceMs={350} value={defaultSourceContext} className={defaultSourceContext ? '' : 'bg-transparent'} placeholder="Any default note on how data was processed..." onChange={(note) => this.setState({ defaultSourceContext: note })} />
        </span>

        {
          <IconButton className='ml-4' disabled={!validProposedValues.length} fill icon="save" level="success" onClick={this.createFragments.bind(this)}>
            Create fragments for {validProposedValues.length} subtrims
          </IconButton>
        }

      </div>

      <div className='p-1'>
        {this.renderSpecsTable()}
      </div>
    </div>;
  }
}

CeroKmMissingSpecsManager.contextType = LegoAdminPageContext;

// For development
function FuncComponent(props) {
  return <CeroKmMissingSpecsManager {...props} />;
}

export default FuncComponent;
